import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/partner.png";
import { Helmet } from "react-helmet";

class PartnersProgram extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>Enterprise Delivery Ecosystem | Avani Cimcon</title>
          <meta
            name="keywords"
            content="Partner Program, software partners, technology partners, consulting partners, distribution partners, software product solutions and IT services, Software Application, Product solutions"
          />
          <meta
            name="description"
            content="Enterprise Delivery Ecosystem describes how Avani Cimcon collaborates with software partners, technology partners, consulting partners and distributors on implementation partnerships and joint enterprise delivery."
          />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">Enterprise Delivery Ecosystem</h1>
            <h5>Technology partnerships, implementation partnerships and platform collaboration</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <h2 className="text-primary">Technology partnerships and platform collaboration</h2>
              <p>
                This page explains how Avani Cimcon works inside a broader delivery ecosystem. The
                emphasis is on joint implementation, systems integration, and platform
                collaboration that helps enterprise customers move work forward.
              </p>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Enterprise delivery ecosystem</h5>
                <p className="mb-0">
                  Avani Cimcon collaborates with companies selected for their experience in systems
                  integration, hardware, software, vertical industries and other critical services.
                </p>
              </div>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Partnership models</h5>
                <ul>
                  <li className="mb-3">
                    <b className="text-primary">Software partners</b>
                    <p>
                      Software partners provide applications that complement, interoperate and add
                      value to enterprise product solutions.
                    </p>
                  </li>

                  <li className="mb-3">
                    <b className="text-primary">Technology partners</b>
                    <p>
                      Technology partners provide hardware systems, platforms, databases, operating
                      systems, equipment, connectivity and hosting services to support and/or extend
                      product solutions.
                    </p>
                  </li>

                  <li className="mb-3">
                    <b className="text-primary">Consulting partners</b>
                    <p>
                      Consulting partners focus on implementation support and domain-specific
                      delivery.
                      Presence within a concentrated geographic region and/or in-depth vertical
                      industry knowledge.
                    </p>
                  </li>

                  <li>
                    <b className="text-primary">Distribution partners</b>
                    <p>
                      Distribution partners provide sales and support resources to resell software
                      licenses and deliver first-line support. These partners operate in assigned
                      geographies and generate business for the broader software and services
                      ecosystem.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="shadow-sm p-4 mt-4">
                <h5 className="text-primary mb-3">Why this page exists</h5>
                <p className="mb-0">
                  The page records ecosystem experience, not a recruitment pitch. Related pages:{" "}
                  <Link to="/objective">Enterprise Collaboration</Link>,{" "}
                  <Link to="/benefits">Benefits of Enterprise Collaboration</Link>, and{" "}
                  <Link to="/it-consulting-services">IT Consulting Services</Link>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PartnersProgram;
